<template>
  <div>
    <ui-modal
      ref="modal"
      @close="actionSetVisibleModalEditarServicioPuerto(false)"
      :title="`Actualizar Puerto - ${titulo}`"
      class="modal-actualizar-servicio-puerto"
    >
      <div class="d-flex flex-column">
        <!-- Cuerpo -->

        <div class="d-flex">
          <ui-textbox
            class="w-50 mr-2"
            floating-label
            label="TT Reefer"
            v-model.number="formulario.TTReeferModel"
          />

          <ui-textbox
            class="w-50 ml-2"
            floating-label
            label="TT Dry"
            v-model.number="formulario.TTDryModel"
          />
        </div>

        <!-- Footer -->
        <div class="d-flex justify-content-between mt-5">
          <button class="btn btn-default" @click="closeModal('modal')">
            Cerrar
          </button>
          <button class="btn btn-primary" @click="actualizarServicioPuerto">
            Guardar
          </button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";

// Constantes
import {
  updateServiciosPuertos,
  getServiciosPuertos,
} from "../../../../constants/lineas";

export default {
  props: {
    dataAux: [Array, Object],
    nombreServicio: { type : String },
  },
  data() {
    return {
      // v-models
      formulario: {
        id_route: "",
        id_port: "",
        TTReeferModel: "",
        TTDryModel: "",
      },
      titulo: "",
    };
  },
  components: {
    UiModal,
    UiTextbox,
  },
  computed: {
    ...mapState("lineas", [
      "idAuxiliarServicioSeleccionado",
      "visibleModalEditarServicioPuerto",
    ]),
  },
  methods: {
    ...mapActions("lineas", [
      "actionSetDataServiciosPuertos",
      "actionSetVisibleModalEditarServicioPuerto",
    ]),

    openModal(ref) {
      this.$refs[ref].open();
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },

    async actualizarServicioPuerto() {
      this.$vToastify.loader("Actualizando servicio");
      this.formulario.nombreServicio = this.nombreServicio;
      let sql = await updateServiciosPuertos(this.formulario);

      if (!sql.error) {
        // Cerrar Modal
        this.closeModal("modal");

        this.$vToastify.stopLoader();
        // Toast proceso exitoso
        this.$vToastify.success("Puerto actualizado con éxito", "¡Realizado!");

        // Limpiar variables
        this.formulario.id_route = "";
        this.formulario.id_port = "";
        this.formulario.TTReeferModel = "";
        this.formulario.TTDryModel = "";

        let dataServiciosPuertosDB = await getServiciosPuertos(
          this.idAuxiliarServicioSeleccionado
        );

        this.actionSetDataServiciosPuertos(
          dataServiciosPuertosDB.data.data_table
        );
      } else {
        if (sql.data.length > 0) {
          // Errores de validación
          sql.data.map((item) => {
            this.$vToastify.error(`${item}`);
          });
        } else {
          // Proceso erroneo
          this.$vToastify.stopLoader();
          this.$vToastify.error(
            "El Puerto no ha podido actualizarse",
            "¡Error!"
          );
        }
      }
    },
  },
  watch: {
    visibleModalEditarServicioPuerto: function (_new) {
      _new && this.openModal("modal");
    },
    dataAux: function (_new) {
      this.formulario.id_route = _new.data_complementaria.id_servicio;
      this.formulario.id_port = _new.data_complementaria.id_puerto;

      // Titulo de modal
      this.titulo = _new.data[0];

      // Formulario
      this.formulario.TTReeferModel = _new.data[1];
      this.formulario.TTDryModel = _new.data[2];
    },
  },
};
</script>

<style>
.modal-actualizar-servicio-puerto .ui-modal__container {
  width: 25% !important;
}
</style>
